// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"2e2f47f6","691":"4875fe65","765":"8aa6d2ff","787":"641f0f2b","970":"e6e2f935","991":"ae45e94e"}[chunkId] + ".chunk.js";
};